import axios from '@/utils/api'

const actions = {

  async getByFilter ({ commit }, { dados }) {
    return axios({
      method: 'post',
      url: 'cadastro-provisorio/find-by-filter',
      data: dados
    })
  },
  async getCadastroProvisorioByRecibo ({ commit }, numeroRecibo) {
    return axios({
      method: 'get',
      url: `cadastro-provisorio/recibo/${numeroRecibo}`
    })
  }

}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/publico/cadastroProvisorio.js